export type HandLayoutEntry = {
  index: number;
  angle: number;
  translateX: number;
  translateY: number;
  zIndex: number;
  raise: number;
};

export type HandLayoutOptions = {
  angle?: number;
  radius?: number;
  angleOffset?: number;
  raise?: number;
};

const DEFAULTS: Required<HandLayoutOptions> = {
  radius: 200,
  angle: 120,
  angleOffset: 0,
  raise: 0,
};

const gauss = (x: number, raise: number) => {
  const a = raise;
  const b = 0;
  const c = 30;
  return a * Math.exp(-Math.pow(x - b, 2) / Math.pow(c, 2));
};

export function computeHandLayout(
  total: number,
  options: HandLayoutOptions = {},
): { fallback: HandLayoutEntry; layout: HandLayoutEntry[] } {
  const { angle, radius, angleOffset, raise } = { ...DEFAULTS, ...options };
  const fallback = {
    index: 0,
    angle: 0,
    translateX: 0,
    translateY: radius,
    zIndex: 0,
    raise: 0,
  };

  let hasPopupCard = false;

  if (total <= 1) {
    return {
      fallback,
      layout: [],
    };
  }

  const halfAngle = angle / 2.0;
  const angleStep = (angle * 1.0) / (total - 1);
  const startAngle = -halfAngle + angleOffset;

  return {
    fallback,
    layout: Array.from({ length: total }).map((_, index) => {
      const angle = startAngle + index * angleStep;
      const translateX = radius * 1.0 * Math.sin((angle * Math.PI) / 180.0);
      const translateY = radius * 1.0 * (1 - Math.cos((angle * Math.PI) / 180.0));
      let handRaise = 0;
      let zIndex = hasPopupCard ? total - index : index;

      if (raise > 0) {
        handRaise = -gauss(translateX, raise);

        if (angle >= -angleStep / 2.0 && angle <= angleStep / 2.0) {
          hasPopupCard = true;
          zIndex = total * 2;
        }
      }

      return { index, angle, translateX, translateY, raise: handRaise, zIndex };
    }),
  };
}
